module.exports = __webpack_public_path__ + "img/17-half-lg.48d68576.jpg";